import { Tooltip } from '@bedrock/components';
import React from 'react';

export default function CharLengthEllipsis({ value, maxLength = 100 }) {
  if (typeof value !== 'string') {
    return value;
  }
  const exceed = value.length > maxLength;
  return exceed ? (
    <Tooltip title={value} overlayStyle={{ maxWidth: 400 }}>
      <span>{value.slice(0, maxLength)}...</span>
    </Tooltip>
  ) : (
    <span>{value}</span>
  )
}